export default {
  name: 'PanelItemAbout',
};
